import { OutputTechnology } from '@enmon/commons/lib/tools';
import { Space } from 'antd';
import type { VFC } from 'react';
import { Tag } from 'components';
import { outputTechnologyTranslated } from 'routes/portfolio/locations/const';

interface InbuiltOutputsProps {
  outputs: OutputTechnology[];
}

export const InbuiltOutputs: VFC<InbuiltOutputsProps> = ({ outputs }) => {
  const filteredOutputs = Object.values(OutputTechnology).filter(output => outputs.includes(output));

  return (
    <Space wrap size={[8, 0]}>
      {Object.values(OutputTechnology).map(output => (
        <Tag key={output} color={filteredOutputs.includes(output) ? 'success' : 'default'}>
          {outputTechnologyTranslated[output]}
        </Tag>
      ))}
    </Space>
  );
};
